import React, { Component } from "react";
import Navbar from "./Navbar";
import ShowNews from "./ShowNews";

class News extends Component {

    render() {
        return (
            <div>
                <Navbar/>

                <header className="masthead bg-primary text-white text-center">
                    <div className="container d-flex align-items-center flex-column">
                        <h1 className="masthead-heading text-uppercase mb-5">Live News Feed</h1>
                    </div>
                </header>
                <section className="page-section portfolio" id="portfolio">
                    <div className="container">
                        <h2 className="page-section-heading text-center text-uppercase text-secondary mb-5">Latest News</h2>

                        <ShowNews/>
                    </div>
                </section>
                <section className="page-section portfolio mb-0" id="portfolio">
                <div className="container">
                    <h3 className="page-section-heading text-center text-uppercase text-secondary mb-0">How the news feed works:</h3>
                    <br/>
                    <div className="row">
                        <div className="col-lg-12 ms-auto text-center"><p className="lead">The news feed uses React's built-in AJAX support to call a REST API web service and gather latest news articles in a JSON format.</p></div>

                    </div>
                </div>
            </section>
            </div>
        );
    }
}


export default News;